/**
 * Expanded video view for the product gallery.
 *
 * Uses an in-page overlay rather than requestFullscreen(): native fullscreen
 * gives the whole screen to the video element, so the Add to Cart button — the
 * reason the video is on a product page at all — would be hidden.
 */
(function () {
  'use strict';
  if (window.__vtheaterInit) return;
  window.__vtheaterInit = true;

  var sourceVideo = null;

  function theater() { return document.getElementById('vtheater'); }

  function build() {
    if (theater()) return theater();
    var form = document.querySelector('[data-product-form]');
    var name = document.querySelector('.product-title-block, h1')?.textContent.trim() || '';
    var price = document.querySelector('.product-price-block__current')?.textContent.trim() || '';

    var el = document.createElement('div');
    el.className = 'vtheater';
    el.id = 'vtheater';
    el.hidden = true;
    el.innerHTML =
      '<button type="button" class="vtheater__close" data-vt-close aria-label="Close video">&times;</button>' +
      '<div class="vtheater__stage"><video class="vtheater__video" data-vt-video controls playsinline></video></div>' +
      '<div class="vtheater__bar">' +
        '<span class="vtheater__meta">' +
          '<span class="vtheater__name">' + name.replace(/</g, '&lt;') + '</span>' +
          '<span class="vtheater__price" data-vt-price>' + price.replace(/</g, '&lt;') + '</span>' +
        '</span>' +
        '<button type="button" class="vtheater__atc" data-vt-atc>Add to Cart</button>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  function open(video) {
    var el = build();
    sourceVideo = video;

    var vt = el.querySelector('[data-vt-video]');
    // carry the source across; Shopify serves HLS plus mp4 fallbacks
    vt.innerHTML = '';
    if (video.currentSrc) {
      vt.src = video.currentSrc;
    } else {
      [].slice.call(video.querySelectorAll('source')).forEach(function (s) {
        vt.appendChild(s.cloneNode(true));
      });
      vt.load();
    }
    vt.poster = video.poster || '';
    vt.currentTime = video.currentTime || 0;
    vt.muted = false;          // expanded view is an explicit "I want to watch this"
    vt.volume = 1;

    // keep the bar price in step with the selected variant
    var price = document.querySelector('.product-price-block__current');
    var pEl = el.querySelector('[data-vt-price]');
    if (price && pEl) pEl.textContent = price.textContent.trim();

    if (!video.paused) video.pause();

    el.hidden = false;
    void el.offsetHeight;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    vt.play().catch(function () {});
  }

  function close() {
    var el = theater();
    if (!el) return;
    var vt = el.querySelector('[data-vt-video]');
    if (vt && !vt.paused) vt.pause();
    // hand playback position back to the gallery
    if (sourceVideo && vt) {
      try { sourceVideo.currentTime = vt.currentTime; } catch (e) {}
    }
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { el.hidden = true; }, 200);
  }

  // add an expand button over each gallery video
  function decorate() {
    document.querySelectorAll('.product-media-gallery__video-wrapper, .product-media-gallery__image-wrapper').forEach(function (wrap) {
      var v = wrap.querySelector('video');
      if (!v || wrap.querySelector('.vtheater-trigger')) return;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vtheater-trigger';
      b.setAttribute('aria-label', 'Expand video');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(v); });
      wrap.appendChild(b);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-vt-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-vt-atc]')) {
      e.preventDefault();
      var form = document.querySelector('[data-product-form]');
      if (form) {
        close();
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    var el = theater();
    if ((e.key === 'Escape' || e.key === 'Esc') && el && !el.hidden) close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
  // the desktop featured video is injected on slide change
  document.addEventListener('click', function () { setTimeout(decorate, 250); });
})();
